// Wrapper um window.localStorage, der Zugriffe abfaengt statt crashen zu lassen.
// Safari im privaten Modus kann bei setItem einen QuotaExceededError werfen;
// ohne diesen Wrapper wuerden Login-/Rejoin-Flows dadurch abbrechen.

function getItem(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (err) {
        console.warn('[safeStorage] getItem fehlgeschlagen:', key, err);
        return null;
    }
}

function setItem(key, value) {
    try {
        window.localStorage.setItem(key, value);
        return true;
    } catch (err) {
        console.warn('[safeStorage] setItem fehlgeschlagen:', key, err);
        return false;
    }
}

function removeItem(key) {
    try {
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        console.warn('[safeStorage] removeItem fehlgeschlagen:', key, err);
        return false;
    }
}

const safeStorage = { getItem, setItem, removeItem };

export default safeStorage;
